module.exports = __webpack_public_path__ + "images/rectangle-1dfe4c03.svg";